// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout__2S5BO"};